import React from "react";

export default {
  "title": "Call for Assistance",
  "needHelp": "We are here to help you.",
  "callAndNumber": "Call 1 (800) 338-2680",
  "mainContent": "With a trusted reputation and always reliable service, you can count on NSD’s 24/7 roadside assistance to be there when the unexpected happens. You’ll have access to everything you need for greater peace of mind on the road—whether you’re around the corner or across the country."
}
